/* angular:styles/component:scss;3fa5024bb7a02e5052a6073cd08972893d7a5c09bd99a134f46fd4e8185b2e22;/home/vsts/work/1/s/src/app/app.component.ts */
.quickView {
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;
  flex-flow: wrap;
}
.quickView .mat-body {
  width: 100%;
  overflow-x: hidden;
  height: 100%;
}
.quick-view-container {
  width: 415px;
}
.quick-view-container .mat-expansion-panel-body {
  padding: 0;
}
.quick-view-padding {
  padding-right: 420px;
}
.mat-body {
  margin: var(--spacing-lg);
}
/*# sourceMappingURL=app.component.css.map */
